"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCancelProposal = void 0;
var web3_js_1 = require("@solana/web3.js");
var serialisation_1 = require("./serialisation");
var borsh_1 = require("borsh");
var instructions_1 = require("./instructions");
var constants_1 = require("../registry/constants");
var withCancelProposal = function (instructions, programId, programVersion, realm, governance, proposal, proposalOwnerRecord, governanceAuthority) {
    var args = new instructions_1.CancelProposalArgs();
    var data = Buffer.from((0, borsh_1.serialize)((0, serialisation_1.getGovernanceInstructionSchema)(programVersion), args));
    var keys = [];
    if (programVersion > constants_1.PROGRAM_VERSION_V1) {
        keys.push({
            pubkey: realm,
            isWritable: true,
            isSigner: false,
        }, {
            pubkey: governance,
            isWritable: true,
            isSigner: false,
        });
    }
    keys.push({
        pubkey: proposal,
        isWritable: true,
        isSigner: false,
    }, {
        pubkey: proposalOwnerRecord,
        isWritable: true,
        isSigner: false,
    }, {
        pubkey: governanceAuthority,
        isWritable: false,
        isSigner: true,
    });
    if (programVersion == constants_1.PROGRAM_VERSION_V1) {
        keys.push({
            pubkey: web3_js_1.SYSVAR_CLOCK_PUBKEY,
            isSigner: false,
            isWritable: false,
        });
    }
    instructions.push(new web3_js_1.TransactionInstruction({
        keys: keys,
        programId: programId,
        data: data,
    }));
};
exports.withCancelProposal = withCancelProposal;
//# sourceMappingURL=withCancelProposal.js.map